import React, { Component } from 'react'
import { Card, Button } from 'antd'
import styled from 'styled-components'

const Container = styled(Card)`
    height: calc(100vh - 120px);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    .image-wrapper {
        img {
            width: 120px;
            animation: jump 1s infinite normal;
            animation-timing-function: ease;
        }
    }
    .title {
        margin-top: 15px;
        font-size: 28px;
        color: #333;
    }
    .copyright {
        margin-top: 5px;
    }
    .button-wrapper {
        margin-top: 30px;
    }
`

class Home extends Component {
    state = {}

    render() {
        let { T } = this.props
        return (
            <Container>
                <div>
                    <div className="image-wrapper">
                        <img src={`${window.config.themeUrl}/manager/static/images/mascot.png`} className="ansimated infiniste bsounce" />
                    </div>
                    <div className="title">{T('WELCOME_TO')} Indymall Manger</div>
                    <div className="copyright">
                        {T('COPYRIGHT')} © {new Date().getFullYear()} {T('BY')}{' '}
                        <a href="https://www.indytheme.com" target="_blank">
                            indytheme.com
                        </a>
                    </div>
                    <div className="button-wrapper">
                        <Button
                            type="primary"
                            size="large"
                            ghost
                            onClick={() => {
                                window.open('https://support.indytheme.com')
                            }}>
                            {T('NEED_HELP')}
                        </Button>
                    </div>
                </div>
            </Container>
        )
    }
}

export default Home
